import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TObjectShareResponse } from "../../../../../services/api/instances/storageApi/types/service_types";
import { AppDatePicker } from "../../../../../shared/components/AppDatePicker";
import { AppLabel } from "../../../../../shared/components/AppLabel";
import { GenericSelect } from "../../../../../shared/components/AppGenericSelect";
import { TPermissionAction } from "../types";
import styles from "./styles.module.css";

interface Props {
  permissions: TObjectShareResponse;
  handleChangeFields: (
    event: string | string[] | Date | null,
    type: TPermissionAction,
    id: string,
  ) => void;
}

export const PermissionsBlock = ({
  permissions,
  handleChangeFields,
}: Props) => {
  const { t } = useTranslation();

  const PERMISSIONS_OPTIONS = [
    t("sidebar.permission_read"),
    t("sidebar.permission_write"),
  ];

  const selectedPermission = useMemo(() => {
    return permissions.write
      ? t("sidebar.permission_write")
      : (t("sidebar.permission_read") ?? t("sidebar.permission_read"));
  }, [permissions]);

  const date = useMemo(() => {
    return new Date(permissions.valid_till);
  }, [permissions.valid_till]);

  return (
    <div className={styles["inputs-container"]}>
      <div className={styles["input-wrapper"]}>
        <AppLabel>Действителен до</AppLabel>
        <AppDatePicker
          value={date}
          onChange={(e) =>
            handleChangeFields(e, "validTill", String(permissions.id))
          }
        />
      </div>
      <div className={styles["input-wrapper"]}>
        <AppLabel>Права доступа</AppLabel>
        <GenericSelect<string>
          options={PERMISSIONS_OPTIONS}
          value={selectedPermission}
          onChange={(e) =>
            handleChangeFields(e, "write", String(permissions.id))
          }
          getLabel={(o) => o}
          getValue={(o) => o}
          className={styles["select"]}
          selectClassName={styles["permission-select"]}
        />
      </div>
    </div>
  );
};
